<template>
  <section class="invitations-read">
    <template>
      <navigation-tabs
        :tabs="tabs"
        class="invitations-read-tabs"
        @selected="selected"
      >
        <template v-slot:new-emails>
          <context-alert
            v-if="!error"
            color="info"
            icon="info-circle"
            class="invitations-context-alert"
          >
            <b>Dica:</b>
            Você pode adicionar um, ou mais de um, email apenas
            copiando e colando eles no campo abaixo.
          </context-alert>

          <context-alert
            v-if="error"
            class="invitations-context-alert"
          >
            Algo deu errado! Por favor, verifique os dados e tente novamente.
          </context-alert>

          <template v-for="(user, index) in users">
            <section
              :key="`form-${user.key}`"
              class="invitations-sections-form"
            >
              <invitations-form
                :ref="`invitation-${index}`"
                :key="`form-${user.key}`"
                :index="index"
                @change="change"
                @paste="paste"
              />

              <form-button
                v-if="users.length > 1"
                :key="`buttons-${user.key}`"
                :icon="['fa', 'trash']"
                size="medium"
                color="danger"
                class="invitations-button-trash"
                @click="remove(index)"
              />
            </section>

            <context-separator
              v-if="sdk.mobile"
              :key="`separator-${user.key}`"
              size="small"
              class="invitations-line-item"
            />
          </template>

          <section class="invitations-button-form">
            <form-button-group align="left">
              <form-button
                :icon="['fa', 'circle-plus']"
                size="small"
                color="highlight"
                class="invitations-button-add"
                @click="() => plus()"
              >
                Adicionar mais pessoas
              </form-button>
            </form-button-group>

            <context-separator
              v-if="!sdk.mobile && users.length <= 1"
              size="small"
              class="invitations-line"
            />

            <form-button-group align="right">
              <form-button
                :icon="['fa', 'paper-plane']"
                size="medium"
                :disabled="users.some(user => !user.email) || userInvitations.batch.loading"
                :loading="userInvitations.batch.loading"
                @click="submit"
              >
                Enviar convite(s)
              </form-button>
            </form-button-group>
          </section>

          <modal-base
            v-if="finished"
            title="Convites enviados"
            center
            class="invitations-modal-sent"
            @close="close"
          >
            <p class="invitations-modal-paragraph">
              Os convites foram enviados!
            </p>

            <p class="invitations-modal-paragraph">
              As informações sobre o status de cadastro estarão na listagem
              <b>Convites enviados.</b>
            </p>
          </modal-base>
        </template>

        <template v-slot:list-emails>
          <invitations-list />
        </template>
      </navigation-tabs>
    </template>
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  // eslint-disable-next-line import/no-extraneous-dependencies
  import preload from '@/helpers/mixins/preload';

  import mobile from '@sdk/helpers/interface/mobile';

  import optionsHelper from '@cordel/helpers/form/select/options';
  import { EMAIL_REGEX } from '@cordel/helpers/form/validators/email';

  import ContextAlert from '@cordel/components/Context/Alert.vue';
  import ContextSeparator from '@cordel/components/Context/Separator.vue';

  import FormButton from '@cordel/components/Form/Button.vue';
  import FormButtonGroup from '@cordel/components/Form/Button/Group.vue';
  import NavigationTabs from '@cordel/components/Navigation/Tabs.vue';
  import ModalBase from '@cordel/components/Modal/Base.vue';

  import InvitationsForm from '@sdk/views/Invitations/Form.vue';
  import InvitationsList from '@sdk/views/Invitations/List.vue';

  import { EMAIL, PERMISSION } from '@sdk/views/Invitations/Form/fields';
import { STORE_ID } from '../Proposals/Approved/fields';

  export default {
    name: 'InvitationsRead',
    components: {
      ContextAlert,
      ContextSeparator,

      FormButton,
      FormButtonGroup,

      InvitationsForm,
      InvitationsList,

      ModalBase,

      NavigationTabs,
    },
    mixins: [
      mobile,
      preload,
    ],
    data() {
      return {
        users: [],

        finished: false,
        error: false,
      };
    },
    computed: {
      ...mapState([
        'userInvitations',
        'domainsWeb',
        'auth',
        'stores',
      ]),

      tabs() {
        return [{
          label: 'Convidar Pessoas',
          slot: 'new-emails',
        }, {
          label: 'Convites Enviados',
          slot: 'list-emails',
        }];
      },

      salesman() {
        const roles = this.domainsWeb.list.items.role;

        return roles.find(i => i.identifier === 'salesman' && !/ext/.test(i.name.toLowerCase()));
      },
      options() {
        const roles = this.domainsWeb.list.items.role;

        if (this.auth.user.role.identifier === 'account_admin') {
         return optionsHelper(this.domainsWeb.list.items.role);
        }

        if (this.auth.user.role.identifier === 'account_manager') {
         return optionsHelper(roles.filter(i => i.identifier !== 'account_admin'));
        }

        if (this.auth.user.role.identifier === 'sales_manager') {
         return optionsHelper(roles.filter(i => i.identifier !== 'account_manager' && i.identifier !== 'account_admin'));
        }

        return optionsHelper(roles.filter(i => i.identifier !== 'account_manager' && i.identifier !== 'account_admin'
                                                 && i.identifier !== 'sales_manager'));
      },
      optionsStore() {
        return optionsHelper(this.stores.list.items);
      },
    },
    mounted() {
      Promise.all([
          this.preloadDomainsWeb(),
          this.preloadStores(),
        ]).then(this.populate);
    },
    methods: {
      populate() {
        this.plus();
      },

      close() {
        this.finished = false;
      },

      plus(email, permission, storeId, index) {
        const last = typeof index === 'number' ? index : this.users.length;

        this.users.splice(last, 1, {
          key: Math.random().toString(36).substr(2),
          email: email || '',
          permission: permission || this.salesman.id,
          store_id: storeId || '',
        });

        this.$nextTick(() => {
          const form = this.$refs[`invitation-${last}`][0];

          form.updateOptions(PERMISSION, this.options);
          form.updateValue(PERMISSION, this.users[last].permission);
          form.updateOptions(STORE_ID, this.optionsStore);
          form.updateValue(STORE_ID, this.users[last].store_id);
          form.updateValue(EMAIL, this.users[last].email);
        });
      },
      remove(index) {
        this.users.splice(index, 1);
      },

      change(field, index, value) {
        switch (field) {
          case EMAIL:
            this.users[index].email = value;
            break;
          case PERMISSION:
            this.users[index].permission = value;
            break;
          case STORE_ID:
            this.users[index].store_id = value;
            break;
          default:
            break;
        }
      },

      paste(field, index, e) {
        this.pasted(field, index, e);
      },
      pasted(field, index, e) {
        const list = e.target.value
          .split(/[, ;\n]/g)
          .filter(x => EMAIL_REGEX.test(x))
          .filter(x => !this.users.some((u, i, a) => u.email === x && a.length > 1 && i !== index));

        const first = list.shift();

        this.plus(first, undefined, '', index);
        list.forEach(email => this.plus(email));
      },

      submit() {
        if (this.users.some(user => !user.email)) {
          this.failure();
        }

        this.error = false;

        const payload = {
          users: this.users.map(user => ({
            email: user.email,
            role_id: user.permission,
            store_ids: [user.store_id],
          })),
        };

        this.$store
          .dispatch('userInvitations/batch', payload)
          .then(this.success)
          .catch(this.failure);
      },

      success() {
        this.finished = true;

        this.users.splice(0, this.users.length);
        this.plus();
      },

      failure() {
        this.error = true;

        try {
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        } catch (err) {
          window.scrollTo(0, 0);
        }
      },

      selected(tab) {
        if (tab.slot !== 'new-emails') {
          return;
        }

        this.$nextTick(() => {
          this.users.forEach((user, index) => {
            const form = this.$refs[`invitation-${index}`][0];

            form.updateOptions(PERMISSION, this.options);
            form.updateValue(PERMISSION, user.permission);
            form.updateOptions(STORE_ID, this.optionsStore);
            form.updateValue(STORE_ID, user.store_id);
            form.updateValue(EMAIL, user.email);
          });
        });
      },
    },
  };
</script>

<style lang="scss">
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .invitations-sections-form {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;

    @media all and (max-width: $cordel-breakpoint-mobile) {
      flex-direction: column;
      align-items: center;
    }

    .cordel-sections {
      margin: 0;
    }
  }

  .invitations-modal-sent {
    .cordel-modal-base-box {
      padding: var(--cordel-spacing-xxxs);
    }
    .cordel-modal-base-title {
      margin-bottom: var(--cordel-spacing-xxxs);
    }
  }
</style>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .invitations-read {
    padding: 0 var(--product--pwa--horizontal);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      padding: 0 var(--product--pwa--horizontal);
    }
  }

  .invitations-context-alert {
    margin: var(--cordel-spacing-blaster) 0 var(--cordel-spacing-xxblaster);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      margin: var(--cordel-spacing-giga) 0 var(--cordel-spacing-blaster);
    }
  }

  .invitations-read-tabs {
  }

  .invitations-line-item {
    margin: 0 var(--cordel-spacing-s);
  }

  .invitations-line {
    @media all and (max-width: $cordel-breakpoint-mobile) {
      margin: var(--cordel-spacing-l) var(--cordel-spacing-s)
              0 var(--cordel-spacing-s);
    }
  }

  .invitations-sections-form {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;

    @media all and (max-width: $cordel-breakpoint-mobile) {
      flex-direction: column;
      align-items: center;
    }
  }

  .invitations-button-trash {
    margin: 0 0 0 var(--cordel-spacing-s);
    height: var(--cordel-spacing-ultra);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      margin: 0 0 var(--cordel-spacing-ultra);
    }
  }

  .invitations-button-form {
    margin: var(--cordel-spacing-blaster) 0 0;

    @media all and (max-width: $cordel-breakpoint-mobile) {
      margin: var(--cordel-spacing-blaster) 0 0;
    }
  }

  .invitations-button-add {
    margin: calc(-1 * var(--cordel-spacing-xxblaster)) 0
            var(--cordel-spacing-ultra) 0;

    @media all and (max-width: $cordel-breakpoint-mobile) {
      margin: calc(-1 * var(--cordel-spacing-l)) 0 var(--cordel-spacing-l) 0;
      width: 100%;
    }
  }

  .invitations-modal-paragraph {
    margin: var(--cordel-spacing-l) 0 var(--cordel-spacing-micro);
  }
</style>
